import { onDomReady } from '../utils/dom';

/**
 * @type {HTMLElement|null}
 */
let root = null;

/**
 * @type {HTMLElement|null}
 */
let inside = null;

/**
 * @type {HTMLElement|null}
 */
let container = null;

// Get the height of the header by the top offset of the next element
export const getHeight = () => container.offsetTop.toFixed(0);

// Get the current height of header_inside.
export const getInnerHeight = () => inside.getBoundingClientRect().height.toFixed(1);

// Get the position from which the header should be fixed.
export const getFixedPosition = () => window.innerHeight / 2;

function showFixedHeader() {
    const scrolledTop = document.documentElement.scrollTop;
    const classList = root.classList;

    /* Während einer Anker-Animation (.auto-scroll) erst sticky werden, wenn auch eine
       darunter liegende Subnav-Leiste (--subnav-height, onePageNav.js) aus dem Bild ist —
       sonst springt die halb sichtbare Leiste beim Anheften erst weg und fährt dann mit
       dem Header wieder ein. */
    const subnavHeight = classList.contains('auto-scroll')
        ? Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--subnav-height')) || 0
        : 0;

    if (scrolledTop > Number.parseInt(getHeight()) + subnavHeight) {
        const wasSticky = classList.contains('sticky');
        classList.add('sticky');

        if (classList.contains('menu-open') || classList.contains('level-open')) {
            classList.add('keep');
        }

        /* .auto-scroll setzt scrolling.js für die Dauer einer Anker-Animation: der Header
           fährt beim Erreichen der Sticky-Schwelle sofort ein und bleibt (.keep), statt
           zwischen Headerhöhe und halber Viewporthöhe aus- und ab der Mitte wieder
           einzufahren. Beim Übergang in .sticky erst einen Frame den Ausgangszustand
           (translateY -101%) rendern lassen, sonst gibt es keine Transition und der
           Header poppt ohne Bewegung ins Bild. */
        if (classList.contains('auto-scroll') && !classList.contains('keep')) {
            if (wasSticky) {
                classList.add('keep');
            } else {
                requestAnimationFrame(() => classList.add('keep'));
            }
        }

        if (scrolledTop > getFixedPosition()) {
            classList.add('show');
        } else {
            classList.replace('show', 'hide');
        }
    } else {
        classList.remove('sticky', 'hide', 'keep', 'show');
    }
}

onDomReady(() => {
    root = document.querySelector('#header');
    inside = root.querySelector('.header_inside');
    container = document.querySelector('#header + div');

    showFixedHeader();
});

window.addEventListener('scroll', () => {
    showFixedHeader();
});

window.addEventListener('resize', () => {
    showFixedHeader();
});
